"use client";

import { ReactNode } from "react";
import { ScrollTracker } from "./scroll-tracker";
import { NavigationTracker } from "./navigation-tracker";

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  return (
    <>
      <ScrollTracker />
      <NavigationTracker />
      {children}
    </>
  );
}
